export const CapabilityReducer = (state, action) => {
  switch (action.type) {
    case "GET_CAPABILITIES":
      const capability = action.capabilities
        ? JSON.parse(action.capabilities.capability)
        : "";
      return {
        ...state,
        data: capability,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/overview/reducers/CapabilityReducer.js